import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/angle-double-right.json)
const angleDoubleRightIconData = {
	icon: {
		attrs: [],
		colorPermutations: {
			'10210410212831741': [],
			'11331341331': [],
			'12402402401': [],
		},
		grid: 14,
		paths: [
			'M448.6 546l-272 272c-18.8 18.8-49.2 18.8-67.8 0l-45.2-45.2c-18.8-18.8-18.8-49.2 0-67.8l192.8-192.8-192.8-192.8c-18.8-18.8-18.8-49.2 0-67.8l45-45.6c18.8-18.8 49.2-18.8 67.8 0l272 272c19 18.8 19 49.2 0.2 68zM832.6 478l-272-272c-18.8-18.8-49.2-18.8-67.8 0l-45.2 45.2c-18.8 18.8-18.8 49.2 0 67.8l192.8 192.8-192.8 192.8c-18.8 18.8-18.8 49.2 0 67.8l45.2 45.2c18.8 18.8 49.2 18.8 67.8 0l272-272c18.8-18.4 18.8-48.8 0-67.6z',
		],
		tags: ['angle-double-right'],
		width: 896,
	},
	attrs: [],
	properties: {
		code: 59704,
		id: 766,
		name: 'angle-double-right',
		order: 3445,
		prevSize: 20,
	},
	setIdx: 1,
	setId: 1,
	iconIdx: 71,
};

// Create IconBuilder from cond-ui-kit data
const AngleDoubleRightIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	angleDoubleRightIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default AngleDoubleRightIconBuilder;
